import PropTypes from 'prop-types';

/* PropTypes */

export const ColumnPopupPropTypes = {
  onClose: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  column: PropTypes.object,
  currentOrder: PropTypes.shape({
    column: PropTypes.string,
    direction: PropTypes.string,
  }),
  filter: PropTypes.string,
  filters: PropTypes.array,
  filterType: PropTypes.string,
  filterValues: PropTypes.array,
  name: PropTypes.string,
  orderColumn: PropTypes.string,
  setFilters: PropTypes.func,
};
